export enum ApplicationType {
  Individual = 'Individual',
  Joint = 'Joint',
}
